import { ListSystemsRequestSchema, ListSystemsResponseSchema } from './list-systems.schema';
/**
 * List Systems Endpoint Contract
 * Retrieves all systems in the organization
 */ export const listSystemsContract = {
    method: 'GET',
    path: '/api/v2/system',
    description: 'Retrieve all systems in the organization',
    requestSchema: ListSystemsRequestSchema,
    responseSchema: ListSystemsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=list-systems.contract.js.map